import {
    TbCar,
    TbCar4Wd,
    TbCarCrane,
    TbCarCrash,
    TbCarGarage,
    TbCarSuv,
    TbCarTurbine,
    TbCarambola,
    TbCarrot,
    TbHome,
    TbHome2,
    TbHomeBolt,
    TbHomeShield,
    TbTool,
    TbTools,
    TbToolsKitchen,
    TbToolsKitchen2,
    TbToolsKitchen3,
    TbTractor,
    TbBus,
    TbPlane,
    TbPlaneArrival,
    TbPlaneDeparture,
    TbSailboat,
    TbSailboat2,
    TbShip,
    TbMotorbike,
    TbMoped,
    TbTruckDelivery,
    TbTruckLoading,
    TbTrain,
    TbRocket,
    TbRollerSkating,
    TbAmbulance,
    TbBuildingHospital,
    TbHospital,
    TbHospitalCircle,
    TbNurse,
    TbCamper,
    TbHeartHandshake,
    TbHeart,
    TbHeartbeat,
    TbHelicopter,
    TbHeartRateMonitor,
    TbMicroscope,
    TbMicrophone2,
    TbMicrophone,
    TbHeadphones,
    TbGitFork,
    TbFlask,
    TbFlask2,
    TbEyeglass,
    TbEyeglass2,
    TbBellSchool,
    TbSchool,
    TbSchoolBell,
    TbShoppingBag,
    TbShoppingBagDiscount,
    TbShoppingCart,
    TbBuildingStore,
    TbShirt,
    TbPaperBag,
    TbAirConditioning,
    TbAirBalloon,
    TbAlarm,
    TbArmchair2,
    TbArmchair,
    TbBabyCarriage,
    TbAward,
    TbAvocado,
    TbBackhoe,
    TbBallTennis,
    TbBalloon,
    TbBallVolleyball,
    TbBed,
    TbBeach,
    TbBike,
    TbBlender,
    TbBomb,
    TbBowlSpoon,
    TbBrandCakephp,
    TbBubble,
    TbBuildingBank,
    TbBuilding,
    TbBuildingCommunity,
    TbBuildingChurch,
    TbBuildingCircus,
    TbBuildingMosque,
    TbBuildingSkyscraper,
    TbBurger,
    TbBuildingWarehouse,
    TbBulldozer,
    TbCandy,
    TbCandle,
    TbCherry,
    TbClipboard,
    TbCloud,
    TbCoffee,
    TbDeviceImac,
    TbDeviceMobile,
    TbDeviceLaptop,
    TbDeviceLandlinePhone,
    TbDeviceIpadHorizontal,
    TbDeviceTv,
    TbDeviceWatch,
    TbDevices2,
    TbDevicesPc,
    TbDice,
    TbDisabled,
    TbDots,
    TbDotsVertical,
    TbDrone,
    TbDroplet,
    TbEPassport,
    TbEye,
    TbFlag,
    TbGift,
    TbGlobe,
    TbGolf,
    TbHelmet,
    TbIroning2,
    TbIroning,
    TbKey,
    TbMail,
    TbMan,
    TbMap,
    TbMapPin,
    TbParachute,
} from 'react-icons/tb';
export const __catIconData = [
    {
        key: 'TbCar',
        icon: TbCar,
    },
    {
        key: 'TbCar4Wd',
        icon: TbCar4Wd,
    },
    {
        key: 'TbCarCrane',
        icon: TbCarCrane,
    },
    {
        key: 'TbCarCrash',
        icon: TbCarCrash,
    },
    {
        key: 'TbCarGarage',
        icon: TbCarGarage,
    },
    {
        key: 'TbCarSuv',
        icon: TbCarSuv,
    },
    {
        key: 'TbCarTurbine',
        icon: TbCarTurbine,
    },
    {
        key: 'TbCarambola',
        icon: TbCarambola,
    },
    {
        key: 'TbCarrot',
        icon: TbCarrot,
    },
    {
        key: 'TbHome',
        icon: TbHome,
    },
    {
        key: 'TbHome2',
        icon: TbHome2,
    },
    {
        key: 'TbHomeBolt',
        icon: TbHomeBolt,
    },
    {
        key: 'TbHomeShield',
        icon: TbHomeShield,
    },
    {
        key: 'TbTool',
        icon: TbTool,
    },
    {
        key: 'TbTools',
        icon: TbTools,
    },
    {
        key: 'TbToolsKitchen',
        icon: TbToolsKitchen,
    },
    {
        key: 'TbToolsKitchen2',
        icon: TbToolsKitchen2,
    },
    {
        key: 'TbToolsKitchen3',
        icon: TbToolsKitchen3,
    },
    {
        key: 'TbTractor',
        icon: TbTractor,
    },
    {
        key: 'TbBus',
        icon: TbBus,
    },
    {
        key: 'TbPlane',
        icon: TbPlane,
    },
    {
        key: 'TbPlaneArrival',
        icon: TbPlaneArrival,
    },
    {
        key: 'TbPlaneDeparture',
        icon: TbPlaneDeparture,
    },
    {
        key: 'TbSailboat',
        icon: TbSailboat,
    },
    {
        key: 'TbSailboat2',
        icon: TbSailboat2,
    },
    {
        key: 'TbShip',
        icon: TbShip,
    },
    {
        key: 'TbMotorbike',
        icon: TbMotorbike,
    },
    {
        key: 'TbMoped',
        icon: TbMoped,
    },
    {
        key: 'TbTruckDelivery',
        icon: TbTruckDelivery,
    },
    {
        key: 'TbTruckLoading',
        icon: TbTruckLoading,
    },
    {
        key: 'TbTrain',
        icon: TbTrain,
    },
    {
        key: 'TbRocket',
        icon: TbRocket,
    },
    {
        key: 'TbRollerSkating',
        icon: TbRollerSkating,
    },
    {
        key: 'TbAmbulance',
        icon: TbAmbulance,
    },
    {
        key: 'TbBuildingHospital',
        icon: TbBuildingHospital,
    },
    {
        key: 'TbHospital',
        icon: TbHospital,
    },
    {
        key: 'TbHospitalCircle',
        icon: TbHospitalCircle,
    },
    {
        key: 'TbNurse',
        icon: TbNurse,
    },
    {
        key: 'TbCamper',
        icon: TbCamper,
    },
    {
        key: 'TbHeartHandshake',
        icon: TbHeartHandshake,
    },
    {
        key: 'TbHeart',
        icon: TbHeart,
    },
    {
        key: 'TbHeartbeat',
        icon: TbHeartbeat,
    },
    {
        key: 'TbHelicopter',
        icon: TbHelicopter,
    },
    {
        key: 'TbHeartRateMonitor',
        icon: TbHeartRateMonitor,
    },
    {
        key: 'TbMicroscope',
        icon: TbMicroscope,
    },
    {
        key: 'TbMicrophone2',
        icon: TbMicrophone2,
    },
    {
        key: 'TbMicrophone',
        icon: TbMicrophone,
    },
    {
        key: 'TbHeadphones',
        icon: TbHeadphones,
    },
    {
        key: 'TbGitFork',
        icon: TbGitFork,
    },
    {
        key: 'TbFlask',
        icon: TbFlask,
    },
    {
        key: 'TbFlask2',
        icon: TbFlask2,
    },
    {
        key: 'TbEyeglass',
        icon: TbEyeglass,
    },
    {
        key: 'TbEyeglass2',
        icon: TbEyeglass2,
    },
    {
        key: 'TbBellSchool',
        icon: TbBellSchool,
    },
    {
        key: 'TbSchool',
        icon: TbSchool,
    },
    {
        key: 'TbSchoolBell',
        icon: TbSchoolBell,
    },
    {
        key: 'TbShoppingBag',
        icon: TbShoppingBag,
    },
    {
        key: 'TbShoppingBagDiscount',
        icon: TbShoppingBagDiscount,
    },
    {
        key: 'TbShoppingCart',
        icon: TbShoppingCart,
    },
    {
        key: 'TbBuildingStore',
        icon: TbBuildingStore,
    },
    {
        key: 'TbShirt',
        icon: TbShirt,
    },
    {
        key: 'TbPaperBag',
        icon: TbPaperBag,
    },
    {
        key: 'TbAirConditioning',
        icon: TbAirConditioning,
    },
    {
        key: 'TbAirBalloon',
        icon: TbAirBalloon,
    },
    {
        key: 'TbAlarm',
        icon: TbAlarm,
    },
    {
        key: 'TbArmchair2',
        icon: TbArmchair2,
    },
    {
        key: 'TbArmchair',
        icon: TbArmchair,
    },
    {
        key: 'TbBabyCarriage',
        icon: TbBabyCarriage,
    },
    {
        key: 'TbAward',
        icon: TbAward,
    },
    {
        key: 'TbAvocado',
        icon: TbAvocado,
    },
    {
        key: 'TbBackhoe',
        icon: TbBackhoe,
    },
    {
        key: 'TbBallTennis',
        icon: TbBallTennis,
    },
    {
        key: 'TbBalloon',
        icon: TbBalloon,
    },
    {
        key: 'TbBallVolleyball',
        icon: TbBallVolleyball,
    },
    {
        key: 'TbBed',
        icon: TbBed,
    },
    {
        key: 'TbBeach',
        icon: TbBeach,
    },
    {
        key: 'TbBike',
        icon: TbBike,
    },
    {
        key: 'TbBlender',
        icon: TbBlender,
    },
    {
        key: 'TbBomb',
        icon: TbBomb,
    },
    {
        key: 'TbBowlSpoon',
        icon: TbBowlSpoon,
    },
    {
        key: 'TbBrandCakephp',
        icon: TbBrandCakephp,
    },
    {
        key: 'TbBubble',
        icon: TbBubble,
    },
    {
        key: 'TbBuildingBank',
        icon: TbBuildingBank,
    },
    {
        key: 'TbBuilding',
        icon: TbBuilding,
    },
    {
        key: 'TbBuildingCommunity',
        icon: TbBuildingCommunity,
    },
    {
        key: 'TbBuildingChurch',
        icon: TbBuildingChurch,
    },
    {
        key: 'TbBuildingCircus',
        icon: TbBuildingCircus,
    },
    {
        key: 'TbBuildingMosque',
        icon: TbBuildingMosque,
    },
    {
        key: 'TbBuildingSkyscraper',
        icon: TbBuildingSkyscraper,
    },
    {
        key: 'TbBurger',
        icon: TbBurger,
    },
    {
        key: 'TbBuildingWarehouse',
        icon: TbBuildingWarehouse,
    },
    {
        key: 'TbBulldozer',
        icon: TbBulldozer,
    },
    {
        key: 'TbCandy',
        icon: TbCandy,
    },
    {
        key: 'TbCandle',
        icon: TbCandle,
    },
    {
        key: 'TbCherry',
        icon: TbCherry,
    },
    {
        key: 'TbClipboard',
        icon: TbClipboard,
    },
    {
        key: 'TbCloud',
        icon: TbCloud,
    },
    {
        key: 'TbCoffee',
        icon: TbCoffee,
    },
    {
        key: 'TbDeviceImac',
        icon: TbDeviceImac,
    },
    {
        key: 'TbDeviceMobile',
        icon: TbDeviceMobile,
    },
    {
        key: 'TbDeviceLaptop',
        icon: TbDeviceLaptop,
    },
    {
        key: 'TbDeviceLandlinePhone',
        icon: TbDeviceLandlinePhone,
    },
    {
        key: 'TbDeviceIpadHorizontal',
        icon: TbDeviceIpadHorizontal,
    },
    {
        key: 'TbDeviceTv',
        icon: TbDeviceTv,
    },
    {
        key: 'TbDeviceWatch',
        icon: TbDeviceWatch,
    },
    {
        key: 'TbDevices2',
        icon: TbDevices2,
    },
    {
        key: 'TbDevicesPc',
        icon: TbDevicesPc,
    },
    {
        key: 'TbDice',
        icon: TbDice,
    },
    {
        key: 'TbDisabled',
        icon: TbDisabled,
    },
    {
        key: 'TbDots',
        icon: TbDots,
    },
    {
        key: 'TbDotsVertical',
        icon: TbDotsVertical,
    },
    {
        key: 'TbDrone',
        icon: TbDrone,
    },
    {
        key: 'TbDroplet',
        icon: TbDroplet,
    },
    {
        key: 'TbEPassport',
        icon: TbEPassport,
    },
    {
        key: 'TbEye',
        icon: TbEye,
    },
    {
        key: 'TbFlag',
        icon: TbFlag,
    },
    {
        key: 'TbGift',
        icon: TbGift,
    },
    {
        key: 'TbGlobe',
        icon: TbGlobe,
    },
    {
        key: 'TbGolf',
        icon: TbGolf,
    },
    {
        key: 'TbHelmet',
        icon: TbHelmet,
    },
    {
        key: 'TbIroning2',
        icon: TbIroning2,
    },
    {
        key: 'TbIroning',
        icon: TbIroning,
    },
    {
        key: 'TbKey',
        icon: TbKey,
    },
    {
        key: 'TbMail',
        icon: TbMail,
    },
    {
        key: 'TbMan',
        icon: TbMan,
    },
    {
        key: 'TbMap',
        icon: TbMap,
    },
    {
        key: 'TbMapPin',
        icon: TbMapPin,
    },
    {
        key: 'TbParachute',
        icon: TbParachute,
    },
];
